const errorMessages = {
	ABORT_ERROR: 'AbortError', // Value comes from AbortController, can't be changed by us.
	ABORTED_ERROR_CODE: 'ABORTED',
};

export default errorMessages;
